import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    externalDriver: translate({ id: 'global.externalDriver' }),
    searchPlaceholder: translate({ id: 'setup.vehicleAssignments.form.list.filterPlaceholder' }),
    yourAssignments: translate({ id: 'setup.driverAssignment.form.list.yourAssignments' }),
    disabledForLoadingTooltip: translate({ id: 'global.gpsLoading.disableEdit' }),
    createNew: translate({ id: 'setup.vehicleAssignments.list.createNew' }),
    entitiesCount: (selected: number, count: number): string =>
      translate({
        id:
          selected > 0
            ? 'setup.vehicleAssignments.list.footerCountWithSelection'
            : 'setup.vehicleAssignments.list.footerCount',
        values: { count, selected },
      }),
    selectBtn: (allSelected: boolean): string =>
      translate({ id: allSelected ? 'global.deselectAll' : 'global.selectAll' }),
    visibilityBtn: (someVisible?: boolean): string =>
      translate({
        id: someVisible ? 'global.hideAll' : 'global.showAll',
      }),
    noEntries: {
      title: translate({ id: 'driverAssignments.list.noEntries.title' }),
      description: translate({ id: 'driverAssignments.list.noEntries.description' }),
      action: translate({ id: 'driverAssignments.list.noEntries.action' }),
    },
    noResults: {
      title: translate({ id: 'driverAssignments.list.noResults.title' }),
      description: translate({ id: 'driverAssignments.list.noResults.description' }),
    },
  }))

  return api
}
